'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _DisclosureTriangle = require('../components/DisclosureTriangle');

var _DisclosureTriangle2 = _interopRequireDefault(_DisclosureTriangle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var navigationSection = state.navigationItems.get(ownProps.navigationItemId);

  return {
    expanded: navigationSection.expanded
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClick: function onClick() {
      dispatch((0, _actions.toggleSectionExpanded)(ownProps.navigationItemId));
    }
  };
};

var SectionDisclosureTriangle = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DisclosureTriangle2.default);

exports.default = SectionDisclosureTriangle;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/containers/SectionDisclosureTriangle.js
// module id = 419
// module chunks = 0